const getCompanies = ({ auth: { companies, partnerCompanies } }) => ({ companies, partnerCompanies });

export default getCompanies;
